<div class="card">
    <div class="p-fluid p-formgrid grid dropdown-card">

        <div class="field col-12 md:col-3">
            <label htmlFor="component">{{'SELECT_TYPE'| translate}}</label>
            <p-dropdown [disabled]="freezeDataDropdown" [options]="typeList" [(ngModel)]="selectedType" appendTo="body"
                placeholder="{{'SELECT'| translate}}" [showClear]="true" optionLabel="value"></p-dropdown>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'SELECT_YEAR'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="yearList" [disabled]="freezeDataDropdown" [(ngModel)]="selectedYear" appendTo="body"
                    placeholder="{{ 'SELECT_YEAR'| translate }}" [showClear]="true" optionLabel="value"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="selectOutletMaster">{{'SELECT_MONTH'| translate}}</label>
            <div class="grid-item">
                <p-dropdown [options]="monthList" [disabled]="freezeDataDropdown" [(ngModel)]="selectedMonth" appendTo="body"
                    placeholder="{{ 'SELECT_MONTH'| translate }}" [showClear]="true" optionLabel="value"></p-dropdown>
            </div>
        </div>

        <div class="field col-12 md:col-3">
            <label></label>
            <div *ngIf="selectedType && selectedYear && selectedMonth"
                class="d-flex justify-content-center align-items-center vh-100 mt-2">
                <button *ngIf="!freezeDataDropdown" (click)="onClickGetData()" pButton pRipple label="{{ 'Get Details' | translate }}"
                    class="p-button-success"></button>

                <button *ngIf="freezeDataDropdown" (click)="clearFreezeOption()" pButton pRipple label="{{ 'Clear Details' | translate }}"
                    class="p-button-help"></button>
            </div>
        </div>
    </div>

    <div *ngIf="showDataTable" class="app-verification-container mt-3 dashboardTable">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <!-- <p-toolbar styleClass="mb-4">
                        <ng-template pTemplate="left">
                            <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                                class="p-button-success"></button>
                            <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button>
                        </ng-template>
                        <ng-template pTemplate="right">
                            <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload>
                            <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                                class="p-button-help"></button>
                            <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                                class="p-button-info ml-3"></button>
                            <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                        </ng-template>
        
                    </p-toolbar> -->

        <p-table #dataTable [columns]="columns" [value]="dataToShow" [rows]="10" [paginator]="true"
            responsiveLayout="scroll" [rowHover]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true" sortMode="multiple">
            <ng-template pTemplate="caption">
                <!-- <div class="flex align-items-center justify-content-between">
                                <h5 class="m-0">{{'FARMER_APPLICATION_FOR_APPROVAL_(PENDING)'| translate}}</h5>
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="dataTable.filterGlobal($any($event.target).value, 'contains')"
                                        placeholder="{{'SEARCH'| translate}}" />
                                </span>
                            </div> -->
                <div class="flex align-items-center justify-content-between">
                    <!-- Left side -->
                    <div class="col-5">
                        <h5 class="m-0 table-header-text">{{selectedType?.value}}{{" - "}}{{selectedMonth?.value}}{{" -
                            "}}{{selectedYear?.value}}
                        </h5>
                    </div>
                    <!-- Middle section for buttons -->
                    <div class="col-3 d-flex  justify-content-between">
                        <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                            class="p-button-help mx-1"></button>
                        <button (click)="refreshTable()" pButton pRipple label="" icon="pi pi-refresh"
                            class="p-button-info mx-1"></button>
                        <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                    </div>
                    <!-- Right side for search -->
                    <div class="col-5 d-flex align-items-center justify-content-end">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="dataTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th *ngFor="let col of columns">
                        {{ col }}
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                        {{ rowData[col] }}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">No Data found.</td>
                </tr>
            </ng-template>
            <!-- <ng-template pTemplate="summary">
                            <div class="flex  justify-content-between flex-column ">
                                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{appVerificationModel ? appVerificationModel.length : 0 }} {{'VERIFICATION_APPLICATIONS_ADDED'| translate}}.
                                </p>
                                <div class="flex  justify-content-between flex-column "> 
                                    <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div>
                                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY'| translate}}</div>
                                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME'| translate}}</div>
                                    <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'DELAYED_APPROVED'| translate}}</div>
                                </div>
                            </div>
                        </ng-template> -->
        </p-table>

        <div *ngIf="showDataTable && dataToShow.length > 0" class="p-fluid p-formgrid justify-content-cente mt-3" style="display: flex; flex-wrap:wrap">
        <!-- <div *ngIf="showDataTable && dataToShow.length > 0"  class="d-flex justify-content-center align-items-center vh-100 mt-2"> -->
            <button pButton pRipple (click)="onSubmitData()" label="{{'Submit Data' | translate}}" class="p-button-success"></button>
            <!-- <button pButton pRipple (click)="onSubmitData()" label="{{'Submit Data' | translate}}" class="p-button-success"
                style="width: 100px; height: 32px; align-items: center;"></button> -->
        </div>

    </div>
</div>